import { SectionTabsLayout, type SectionTabItem } from "./section-tabs-layout";

const MODERATION_TABS: SectionTabItem[] = [
  {
    label: "Queue",
    to: "/moderation/queue",
    match: (pathname) => pathname.startsWith("/moderation/queue"),
  },
  {
    label: "Authorized Publishers",
    to: "/moderation/authorized-publishers",
    match: (pathname) => pathname.startsWith("/moderation/authorized-publishers"),
  },
  {
    label: "Test Rubric",
    to: "/moderation/probe",
    match: (pathname) => pathname.startsWith("/moderation/probe"),
  },
  {
    label: "Judge",
    to: "/moderation/judge",
    match: (pathname) => pathname.startsWith("/moderation/judge"),
  },
];

export function ModerationLayout() {
  return <SectionTabsLayout id="moderation" items={MODERATION_TABS} />;
}
